import React, {useCallback, useState} from 'react'
import { Modal, TextContainer, Icon} from '@shopify/polaris'
import {ChevronRightMinor} from '@shopify/polaris-icons';
import './modal_image.css'

export default function ModalImage(props) {
    
  const [active, setActive] = useState(false);
  
  const handleChange = useCallback(() => setActive(!active), [active]);
  const activator = <button className='btn-more'
    onClick={handleChange}>
      more 
      <div className='polaris-icon-custom'><Icon source={ChevronRightMinor}/></div>
    </button>;

  return (
    <div onClick={handleChange}>
      <Modal
        activator={activator}
        open={active}
        onClose={handleChange}
        title={props.title}
        // primaryAction={{
        //   content: 'Add Instagram',
        //   onAction: handleChange,
        // }}
        // secondaryActions={[
        //   {
        //     content: 'Learn more',
        //     onAction: handleChange,
        //   },
        // ]}
      >
        <p className='text-center'><small>{props.date}</small></p>
        <img src={props.img_url} width="1000" alt={props.title} className='modal__img'></img>
        <p className='text-center'><small>{props.copyright}</small></p>
        <Modal.Section>
          <TextContainer>
            <p>
              {props.description}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    </div>
  );
}